import axios from "axios";
import { getURL } from "./functions";
import { axiosInstance } from "../axiosconfing";
let header = {
  "Access-Control-Allow-Origin": "*",
  "Content-Type": "application/json; charset=UTF-8",
};

export const postRequestWithoutToken = async (api_url, dataToSend) => {
  try {
    const data = await axios.post(
      `${import.meta.env.VITE_API_BASE_URL}${api_url}`,
      {
        ...dataToSend,
      },
      {
        headers: header,
      }
    );
    return data;
  } catch (error) {
    throw error;
  }

  // try {
  //     let response = await fetch(getURL() + api_url, {
  //         method: "POST",
  //         headers: header,
  //         body: JSON.stringify(dataToSend)
  //     });
  //     if (response.ok) {
  //         response = await response.json();
  //         return response;
  //     }
  //     else {
  //         throw new Error("Request Failed")
  //     }
  // } catch (error) {
  //     console.error("Error", error);
  //     throw error;
  // }
};

/* Get Request */
export const getRequest = async (api_url) => {
  try {
    const data = await axios.get(
      `${import.meta.env.VITE_API_BASE_URL}${api_url}`,
      { headers: header }
    );
    return data;
  } catch (error) {
    throw error;
  }

  // try {
  //     let response = await fetch(getURL() + api_url, {
  //         method: "GET",
  //         headers: header,
  //     });
  //     if (response.ok) {
  //         response = await response.json();
  //         return response;
  //     }
  //     else {
  //         throw new Error("Request Failed")
  //     }
  // } catch (error) {
  //     console.error("Error", error);
  //     throw error;
  // }
};
export const getRequestQa = async (api_url) => {
  try {
    const data = await axios.get(
      `${import.meta.env.VITE_API_BASE_URL_V3}${api_url}`,
      { headers: header }
    );
    return data;
  } catch (error) {
    throw error;
  }

  // try {
  //     let response = await fetch(getURL() + api_url, {
  //         method: "GET",
  //         headers: header,
  //     });
  //     if (response.ok) {
  //         response = await response.json();
  //         return response;
  //     }
  //     else {
  //         throw new Error("Request Failed")
  //     }
  // } catch (error) {
  //     console.error("Error", error);
  //     throw error;
  // }
};
export const getRequestChatApi = async (api_url) => {
  try {
    const token = import.meta.env.VITE_CHAT_TOKEN; // access token from environment variable
    const data = await axios.get(
      `${import.meta.env.VITE_CHAT_API_URL}${api_url}`,
      {
        headers: {
          ...header,
          Authorization: `Bearer ${token}` // add the token here
        }
      }
    );
    return data.data;
  } catch (error) {
    throw error;
  }
};

export const postRequest = async (api_url, bodyData, headers) => {
  try {
    const data = await axiosInstance.post(api_url, bodyData);
    return data;
  } catch (error) {
    throw error;
  }
};

export const postRequestTest = async (api_url, bodyData, additionalHeaders) => {
  let token = localStorage.getItem("token");
  let headers = {
    // "Content-Type": "application/json; charset=UTF-8",
    'Access-Control-Allow-Origin': "*",
  };

  if (token !== null) {
    headers["Authorization"] = "Bearer " + token;
  }

  if (additionalHeaders) {
    Object.assign(headers, additionalHeaders);
  }

  try {
    const data = await axios.post(
      `${import.meta.env.VITE_API_BASE_URL3}${api_url}`,
      bodyData,
      {
        headers: headers,
      }
    );
    return data;
  } catch (error) {
    throw error;
  }
};

export const postRequestBeta = async (api_url, bodyData, additionalHeaders) => {
  let fetch_url = getURL() + api_url;
  console.log(fetch_url, " this is fetch url");

  let token = localStorage.getItem("token");
  console.log("token....................", token);

  let headers = {
    "Content-Type": "application/json; charset=UTF-8",
  };

  if (token !== null) {
    headers["Authorization"] = "Bearer " + token;
  }

  // Include any additional headers from the 'additionalHeaders' parameter
  if (additionalHeaders) {
    Object.assign(headers, additionalHeaders);
  }

  try {
    const data = await axios.post(
      `${import.meta.env.VITE_API_BASE_URL_BETA}${api_url}`,
      bodyData,
      {
        headers: headers,
      }
    );
    return data;
  } catch (error) {
    throw error;
  }
};

export const getRequestWithToken = async (api_url) => {
  try {
    const data = await axiosInstance.get(api_url);
    return data;
  } catch (error) {
    throw error;
  }
};

export const patchRequestWithToken = async (api_url, bodyData) => {

  try {
    const data = await axiosInstance.patch(api_url, bodyData);
    return data;
  } catch (error) {
    throw error;
  }
};

export const putRequestWithToken = async (api_url, bodyData) => {
  try {
    const data = await axiosInstance.put(api_url, bodyData);
    return data;
  } catch (error) {
    throw error;
  }
};

export const patchRequestWithTokenBeta = async (api_url, bodyData) => {
  let token = localStorage.getItem("token");
  let headers = {
    "Content-Type": "application/json; charset=UTF-8",
  };

  if (token !== null) {
    headers["Authorization"] = "Bearer " + token;
  }

  try {
    const data = await axios.patch(
      `${import.meta.env.VITE_API_BASE_URL2}${api_url}`,
      bodyData,
      {
        headers: headers,
      }
    );
    return data;
  } catch (error) {
    throw error;
  }
};

export const deleteRequest = async (api_url, optionData) => {
  // let fetch_url = getURL() + api_url;
  // let token = localStorage.getItem("token");

  try {
    const data = await axiosInstance.delete(api_url, {
      data: optionData,
    });
    return data;
  } catch (error) {
    throw error;
  }

  // if (token != null)
  //     header = {
  //         'Access-Control-Allow-Origin': "*",
  //         'authorization': 'Bearer ' + token
  //     };

  // let data = await fetch(fetch_url, {
  //     method: "DELETE",
  //     headers: header,
  //     body: JSON.stringify(bodyData),
  // });
  // if (data.ok) {
  //     data = await data.json();
  //     return data;
  // }
};

export const uploadImage = async (api_url, dataToSend) => {
  let storedToken = localStorage.getItem("token");
  try {
    let response = await fetch(
      `${import.meta.env.VITE_API_BASE_URL}${api_url}`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${storedToken}`,
        },
        body: dataToSend,
      }
    );
    if (response.ok) {
      response = await response.json();
      return response;
    } else {
      throw new Error("Request Failed");
    }
  } catch (error) {
    console.error("Error", error);
    throw error;
  }
};

export const getRequestWithTokenV3 = async (api_url) => {
  let storedToken = localStorage.getItem("token");
  let headers = {
    "Content-Type": "application/json; charset=UTF-8",
  };

  if (storedToken !== null) {
    headers[`Authorization`] = `Bearer ${storedToken}`;
  }
  try {
    let response = await fetch(
      `${import.meta.env.VITE_API_BASE_URL_V3}${api_url}`,
      {
        method: "GET",
        headers: headers,
      }
    );
    if (response.ok) {
      response = await response.json();
      return response;
    } else {
      throw new Error("Request Failed");
    }
  } catch (error) {
    throw error;
  }
};

export const postRequestWithTokenWithQA = async (api_url, dataToSend) => {
  let token = localStorage.getItem("token");

  let headers = {
    "Content-Type": "application/json; charset=UTF-8",
  };

  if (token !== null) {
    headers["Authorization"] = "Bearer " + token;
  }

  try {
    const data = await axios.post(
      `${import.meta.env.VITE_API_BASE_QA_URL}${api_url}`,
      {
        ...dataToSend,
      },
      {
        headers: header,
      }
    );
    return data;
  } catch (error) {
    throw error;
  }

  // try {
  //     let response = await fetch(getURL() + api_url, {
  //         method: "POST",
  //         headers: header,
  //         body: JSON.stringify(dataToSend)
  //     });
  //     if (response.ok) {
  //         response = await response.json();
  //         return response;
  //     }
  //     else {
  //         throw new Error("Request Failed")
  //     }
  // } catch (error) {
  //     console.error("Error", error);
  //     throw error;
  // }
};

export const getRequestTemplate = async (api_url) => {
  let storedToken = import.meta.env.VITE_API_BASE_URL_TEMPLATE_TOKEN;
  let headers = {
    "Content-Type": "application/json; charset=UTF-8",
  };

  if (storedToken !== null) {
    headers[`Authorization`] = `Bearer ${storedToken}`;
  }
  try {
    let response = await fetch(
      `${import.meta.env.VITE_API_BASE_URL_TEMPLATE}${api_url}`,
      {
        method: "GET",
        headers: headers,
      }
    );
    if (response.ok) {
      response = await response.json();
      return response;
    } else {
      throw new Error("Request Failed");
    }
  } catch (error) {
    throw error;
  }
};

export const getRequestForResume = async (api_url) => {
  let token = localStorage.getItem("token");
  try {
    let response = await fetch(`${import.meta.env.VITE_API_BASE_URL}${api_url}`, {
      method: "GET",
      headers: {
        ...header,
        'Authorization': `Bearer ${token}`
      },
    });


    if (response.ok) {
      //for returning the raw text;
      return response.text();
    }
    else {
      throw new Error("Request Failed")
    }
  } catch (error) {
    console.error("Error", error);
    throw error;
  }
}

export const postRequestForLinkShortener = async (dataToSend) => {
  let headers = {
    "Content-Type": "application/json",
    "x-api-key": import.meta.env.VITE_URL_SHORTENER_API_KEY,
  };
  try {

    const response = await fetch(import.meta.env.VITE_LINK_SHORTENER_API_URL, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(dataToSend),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response.json(); // Parse the response as JSON
  } catch (error) {
    console.error("Error in API call:", error);
    throw error;
  }
}

export const getRequestForLinkShortener = async (url) => {
  try {
    let headers = {
      "Content-Type": "application/json",
      "x-api-key": import.meta.env.VITE_URL_SHORTENER_API_KEY,
    };
    const response = await fetch(import.meta.env.VITE_LINK_SHORTENER_API_URL + url, {
      method: "GET",
      headers: headers,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response.json(); // Parse the response as JSON
  } catch (error) {
    console.error("Error in API call:", error);
    throw error;
  }
}

export const getRequestForJobExpertise = async (url) => {
  try {
    let headers = {
      "Content-Type": "application/json",
      "x-api-key": import.meta.env.VITE_API_KEY_FOR_JOB_EXPERTISE,
    };
    const response = await fetch(import.meta.env.VITE_JOB_EXPERTISE_API_URL + url, {
      method: "GET",
      headers: headers,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response.json(); // Parse the response as JSON
  } catch (error) {
    console.error("Error in API call:", error);
    throw error;
  }
}
export const getRequestWithTokenV3staging = async (api_url) => {
  let storedToken = localStorage.getItem("token");
  let headers = {
    "Content-Type": "application/json; charset=UTF-8",
  };

  if (storedToken !== null) {
    headers[`Authorization`] = `Bearer ${storedToken}`;
  }
  try {
    let response = await fetch(
      `${import.meta.env.VITE_JOB_EXPERTISE_API_URL}${api_url}`,
      {
        method: "GET",
        headers: headers,
      }
    );
    if (response.ok) {
      response = await response.json();
      return response;
    } else {
      throw new Error("Request Failed");
    }
  } catch (error) {
    throw error;
  }
};